import { TileCard } from "@dash/tile";
import { MdList } from "react-icons/md";

import { RelationType } from "@megaron/crm-contracts";
import { Uuid } from "@megaron/uuid";
import { getMegaraxPath } from "@megaron/megarax-uri";

type Props = {
  count: number;
  category:
    | "invitedChildrenCount"
    | "supplyPointChildrenCount"
    | "payerChildrenCount"
    | "distributorChildrenCount"
    | "chainChildrenCount";
  customerUuid: Uuid;
};

export const RelatedCustomerTile: React.FC<Props> = ({ count, category, customerUuid }) => {
  const categoryDetails: Record<string, { tileLabel: string; relationType: RelationType }> = {
    invitedChildrenCount: { tileLabel: "Zaproszeni wykonawcy", relationType: "invitedBy" },
    supplyPointChildrenCount: { tileLabel: "Jako punkt sprzedaży", relationType: "supplyPoint" },
    payerChildrenCount: { tileLabel: "Jako płatnik", relationType: "payer" },
    distributorChildrenCount: { tileLabel: "Jako dystrybutor", relationType: "distributor" },
    chainChildrenCount: { tileLabel: "Jako sieć", relationType: "chain" },
  };

  const relation = {
    relationType: categoryDetails[category].relationType,
    parents: [customerUuid],
  };

  const filters = {
    page: 0,
    searchText: "",
    sort: undefined,
    isPro: false,
    isAffiliate: false,
    relation: relation,
  };

  return (
    <TileCard
      href={getMegaraxPath.uri("megarax://crm/customers/new-list", { filters })}
      css={{ "&:hover": { cursor: "pointer" } }}
      key={category}
      Icon={MdList}
      label={categoryDetails[category].tileLabel}
      value={count > 0 ? `${count} ${count > 1 ? "klientów" : "klient"}` : "Brak"}
      isActive
    />
  );
};
